import React, { useState } from 'react';
import SimpleDateField from 'components/basic/SimpleDateField';
import { makeStyles, Grid, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@material-ui/core';
import axiosClient from 'http/axios-client';
import { parseDate } from 'components/business/consents/ConsentsTable';
import { useAlerts } from 'hooks/alerts-hooks';

const useStyles = makeStyles({
  button: {
    margin: '0px 0px 0px 5px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
  infoButton: {
    color: '#ffffff',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
  dialogPaper: {
    width: '100%',
    maxWidth: 600,
  },
  dialogContent: {
    backgroundColor: '#f3f3f3',
  },
});

function ManagersSampleReceivedForm({ kit, country, refetch }) {
  const classes = useStyles();
  const today = new Date().toISOString().split('T')[0];
  const [ selectedDate, setSelectedDate ] = useState(today);
  const [ selected, setSelected ] = useState({});
  const [ openDialog, setOpenDialog ] = useState(false);
  const { alertSuccess, alertError } = useAlerts();

  function setSampleReceivedDate(serial, date) {
    const isoDate = new Date(date).toISOString();
    // first request
    axiosClient.put(`/registration-kits/idna-update/${ serial }`, {
      sampleReceivedDate: isoDate,
    }).then(() => {
      alertSuccess('Sample Received Date is set.');
      // second request
      axiosClient.put(`/registration-kits/idna-sample/${ serial }`,
        { registrationStatus: 'sample_received' }).then(() => {
        alertSuccess('Registration Status changed to Sample Received.');
      }).catch(() => {
        alertError('Fail to set Registration Status');
      });
    }).catch(() => {
      alertError('Fail to set Date');
    });
    setOpenDialog(false);
    setSelected({});
    refetch();
  }

  return (
    <>
      <Grid container alignItems='center'>
        <Grid item xs={ 8 }>
          <SimpleDateField
            value={ selectedDate }
            defaultValue={ today }
            label='Set Sample Received Date'
            name='selectedDate'
            country={ country }
            required={ false }
            onChange={ (v) => {
              setSelectedDate(v);
            } }
          />
        </Grid>
        <Grid item xs={ 4 } style={ { alignSelf: 'flex-end' } }>
          <Button
            className={ classes.infoButton }
            onClick={ () => {
              setSelected(kit);
              setOpenDialog(true);
            } }
          >
            Set
          </Button>
        </Grid>
      </Grid>
      <Dialog
        open={ openDialog }
        onClose={ () => { setSelected({}); setOpenDialog(false); } }
        classes={ { paper: classes.dialogPaper } }
      >
        <DialogContent className={ classes.dialogContent }>
          <DialogContentText>
            <Grid container xs={ 12 } style={ { display: 'flex', justifyContent: 'center' } }>
              <Grid item xs={ 12 } style={ { display: 'flex', justifyContent: 'center' } }>
                <Typography variant='h6'>
                  Set Sample Received Date
                  {' '}
                  { parseDate(selectedDate)}
                  {' '}
                  for serial:
                  {' '}
                  {selected?.serial_number_id?.serial}
                  {' '}
                  ?
                </Typography>
              </Grid>
              <Grid item xs={ 12 } style={ { display: 'flex', justifyContent: 'center' } }>
                If you confirm, you will not longer be able to change this sample received date and an email will be send automatically to the client.
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid item xs={ 12 } style={ { display: 'flex', justifyContent: 'flex-end' } }>
            <Button
              className={ classes.button }
              onClick={ () => {
                setSelected({});
                setOpenDialog(false);
              } }
            >
              Cancel
            </Button>
            <Button
              className={ classes.button }
              onClick={ () => {
                setOpenDialog(false);
                setSampleReceivedDate(selected?.serial_number_id?.serial, selectedDate);
              } }
            >
              Confirm
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManagersSampleReceivedForm;
